module.exports = __webpack_public_path__ + "a842261479b49eaee8a1be905f8df13c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/send_email.png
// module id = 310
// module chunks = 0